<template>
  <component
    :is="typeInput"
    :type="type"
    v-bind="inputProps"
    @update:value="$emit('update:value', $event)"
    @blur="$emit('blur')"
  />
</template>

<script>
import CalendarInput from "../CalendarInput";
import CheckboxInput from "../CheckboxInput";
import CreditCardInput from "../CreditCardInput";
import RadioButtonsGroup from "../RadioButtonsGroup";
import RangeInput from "../RangeInput";
import SelectInput from "../SelectInput";
import TelInput from "../TelInput/TelInput";
import TextArea from "../TextArea";
import TextInput from "../TextInput";

export default {
  name: "DynamicInput",

  components: {
    CalendarInput,
    CheckboxInput,
    RadioButtonsGroup,
    RangeInput,
    SelectInput,
    TextArea,
    TelInput,
    TextInput,
  },

  props: {
    type: {
      type: String,
      default: "text",
      validator(type) {
        return [
          "calendar",
          "credit-card",
          "text",
          "date",
          "datetime",
          "email",
          "number",
          "phone",
          "password",
          "select",
          "checkbox",
          "textarea",
          "range",
          "radio",
        ].includes(type);
      },
    },
    inputProps: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    typeInput() {
      switch (this.type) {
        case "date":
        case "email":
        case "number":
        case "password":
        case "text":
          return TextInput;
        case "phone":
          return TelInput;
        case "checkbox":
          return CheckboxInput;
        case "select":
          return SelectInput;
        case "textarea":
          return TextArea;
        case "calendar":
          return CalendarInput;
        case "credit-card":
          return CreditCardInput;
        case "range":
          return RangeInput;
        case "radio":
          return RadioButtonsGroup;
      }
      return null;
    },
  },
};
</script>
